import { Injectable } from '@angular/core';
import { DomListenerService } from './dom-listener.service';
import { DomHandlersService } from './dom-handlers.service';
import { Options } from './dom-handler.dto';

@Injectable({
  providedIn: 'root'
})
export class DomHelperService {

  constructor(
    private domListenerService:DomListenerService,
    private domHandlersService:DomHandlersService  
  ) { }

  /**
   * init the event listner with the function name
   * @param elementOrSelector 
   * @param event 
   * @param functionName 
   */
  initializeEventListener(elementOrSelector: NodeListOf<HTMLElement> | string, event: string, functionName:string, options:Options = {}){
    this.domListenerService.addListener(elementOrSelector, event, (event) => {
        this.domHandlersService[functionName](event,options);
    });
  }
}
